{
  "loading": "Vérification de votre demande…",
  "title": "Demande d’enlèvement",
  "introduction": "Vous souhaitez demander à votre partenaire {storeName} de venir déclencher au plus vite le SAV suivant :",
  "photo": {
    "label": "Prenez en photo votre Palette BOX / Carton afin que le magasin organise le transport associé",
    "dropzoneTitle": "Déposez la photo ici",
    "acceptedFormats": "Formats acceptés : JPG, PNG, HEIC (10 Mo maximum)",
    "takePhoto": "Prendre une photo",
    "remove": "Supprimer la photo",
    "hint": "Une photo est nécessaire pour permettre au magasin d’organiser le transport associé.",
    "errors": {
      "required": "Une photo est requise.",
      "type": "La photo doit être au format JPEG, PNG ou HEIC.",
      "size": "La photo ne doit pas dépasser 10 Mo."
    }
  },
  "availableFromDate": {
    "label": "À partir de quelle date le magasin peut-il venir chercher votre lot SAV ?",
    "placeholder": "JJ/MM/AAAA"
  },
  "phoneNumber": {
    "label": "Sur quel numéro peut-il vous contacter lors de son arrivée sur site ?",
    "placeholder": "Numéro de téléphone sur site"
  },
  "comment": {
    "label": "Avez-vous un commentaire à ajouter ? (facultatif)",
    "placeholder": "Ajoutez toute information utile pour l’enlèvement"
  },
  "preparation": "Un grand merci pour votre confiance. Nous vous remercions de préparer la palette / le colis le mieux possible afin de simplifier le transport.",
  "submit": "Envoyer la demande",
  "retrySubmission": "Réessayer l’envoi",
  "submissionError": "La demande n’a pas pu être envoyée. Vos informations sont conservées ; veuillez réessayer.",
  "captchaError": "La vérification de sécurité n’a pas pu aboutir. Vos informations sont conservées ; veuillez réessayer.",
  "loadError": {
    "title": "Impossible de vérifier le lien",
    "message": "Une erreur de connexion empêche la vérification de votre demande. Veuillez réessayer.",
    "retry": "Réessayer"
  },
  "invalid": {
    "title": "Lien invalide ou révoqué",
    "message": "Ce lien n’est plus valide. Veuillez contacter votre interlocuteur SAV."
  },
  "success": {
    "title": "Demande envoyée",
    "message": "Merci. Votre demande a bien été transmise. Veuillez préparer la Palette BOX / le Carton pour son enlèvement."
  }
}
